import { render, staticRenderFns } from "./AssignClientClasses.vue?vue&type=template&id=9ee7a002"
import script from "./AssignClientClasses.vue?vue&type=script&lang=js"
export * from "./AssignClientClasses.vue?vue&type=script&lang=js"
import style0 from "./AssignClientClasses.vue?vue&type=style&index=0&id=9ee7a002&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports